import Content from './content';
import FooterBarComponents from './footerbar/export';
import SidebarComponents from './sidebar/export';
import StyleComponents from './style/export';
import ToolbarComponents from './toolbar/export';
import Viewer2DComponents from './viewer2d/export';

export {
  Content, FooterBarComponents, SidebarComponents, StyleComponents, ToolbarComponents, Viewer2DComponents
};

export default {
  ToolbarComponents,
  Content,
  SidebarComponents,
  FooterBarComponents,
  Viewer2DComponents,
  StyleComponents
};
